import { __decorate } from "tslib";
import { Module, MutationAction, VuexModule } from 'vuex-module-decorators';
import { Api } from '@/domains/api';
let ProfileStore = class ProfileStore extends VuexModule {
    constructor() {
        super(...arguments);
        this.profile = undefined;
    }
    async fetch() {
        const response = await Api.Profile.Get();
        return {
            profile: response.data,
        };
    }
};
__decorate([
    MutationAction({ mutate: ['profile'] })
], ProfileStore.prototype, "fetch", null);
ProfileStore = __decorate([
    Module({
        namespaced: true,
    })
], ProfileStore);
export default ProfileStore;
export * from './type';
